import React from "react";
import {  MDBContainer, MDBRow, MDBCol, MDBIcon } from "mdbreact";
import Strategy from '../components/strategy';
import Development from '../components/development';
import Managed from "../components/managedServices";
import Layout from "../components/layout";
import HoverGridService from '../components/hoverGridService'


const ServicesPage = () => {
  return (
    <Layout >
      <section className="text-center mt-5">
        <MDBContainer  className="text-center my-5">
          <h4 className="my-5">
              At Fuzzy Digital we can advise you on your technology strategy, 
              work with you to build websites, applications and mobile 
              applications to take your business further and manage services 
              to help you engage with your clients.
          </h4>
        </MDBContainer>
        
        <MDBRow className="smallSection peoplebg">
      
        </MDBRow>
        <MDBRow className="smallSection">
          <Strategy />
        </MDBRow>
        <MDBRow className="smallSection greybg">
          <Development />
        </MDBRow>
        <MDBRow className="smallSection">
          <Managed />
        </MDBRow>
        <HoverGridService />
      </section>
    </Layout>
  );
}

export default ServicesPage;